import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Button,  ThemeProviderV2} from '@blueprint/ui';
import { useModal } from "react-modal-hook";

import usersApi, { useUserById } from "../../../api/users";
import { Loader, toast } from "../../../common/components/core";
import { useAuthErrorHandlerCreator } from "../../../common/hooks";
import { useGeneralErrorHandlerCreator } from "../../../common/hooks/useGeneralErrorHandler";
import {
    GenericError,
    composeErrorHandlers,
} from "../../../utils/errorHandling";


type DeactivateHandler = {
    isSubmitting: boolean;
    handler: (
        name: string,
    ) => void;
};

const useDeactivateHandler = (userId: string): DeactivateHandler => {
    const [ isSubmitting, setSubmitting ] = useState(false);
    const [ name, setName ] = useState<string>("");
    const onAuthError = useAuthErrorHandlerCreator();
    const useGeneralError = useGeneralErrorHandlerCreator();
    const { mutate } = useUserById(userId);

    const [show, hide] = useModal(() => {
        const confirm = async () => {
            setSubmitting(true);
            try {
                await usersApi.deactivate(userId);
                mutate();
                toast("User Deactivated");
            } catch (e) {
                composeErrorHandlers(
                    onAuthError,
                    useGeneralError,
                )(e as GenericError);
            }
            hide();
            setSubmitting(false);
        };

        return (
            <ThemeProviderV2>
            <Modal show onHide={hide} backdrop="static" centered>
                <Loader overlay isLoading={isSubmitting}>
                    <Modal.Header>
                        <h2 className="mb-0">
                            Deactivate User
                        </h2>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{`Are you sure you want to deactivate user “${name}”?`}</p>
                    </Modal.Body>

                    <Modal.Footer className="d-flex justify-content-between px-3">
                        <Button variant="light.tertiary" onClick={hide}>
                            Cancel
                        </Button>
                        <Button variant="light.primary" onClick={confirm}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Loader>
            </Modal>
            </ThemeProviderV2>
        );
    }, [ mutate, userId, isSubmitting, name, onAuthError]);

    return {
        isSubmitting,
        handler: (name) => {
            setName(name);
            show();
        },
    };
};

export default useDeactivateHandler;
